import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import TokenImage from 'app/components/ui/TokenImage';
import Tooltip from 'app/components/ui/Tooltip';
import { shortize } from 'app/utils/helpers';
import Version from 'app/components/ui/Version';

import s from './TokenName.module.sass';

type TokenNameProps = {
  firstTokenImage: string | null
  secondTokenImage?: string | null
  name: string
  href?: string
  to?: string
  isShortize?: boolean
  sizeT?: 'small' | 'medium' | 'large' | undefined
  className?: string
  tokensNames: {
    firstTokenName: string
    secondTokenName?: string
  }
  withoutTooltip?: boolean
  version?: string
};

const TokenName: React.FC<TokenNameProps> = ({
  firstTokenImage,
  secondTokenImage,
  name,
  href,
  to,
  sizeT = 'medium',
  tokensNames,
  className,
  withoutTooltip = false,
  isShortize = false,
  version,
}) => {
  const [isShowTooltip, setIsShowTooltip] = useState<boolean>(false);

  const urlLength = name.length > 11;

  const handleMouseEnter = () => {
    if (urlLength) {
      setIsShowTooltip(true);
    }
  };

  const content = (
    <div
      className={cx(s.root)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setIsShowTooltip(false)}
    >
      <TokenImage
        firstTokenImage={firstTokenImage}
        secondTokenImage={secondTokenImage}
        sizeT={sizeT}
        tokensNames={tokensNames}
      />
      <div className={cx(s.tokenWrapper, { [s.noLink]: !to && !href })}>
        <div className={cx(s.tokenUrl)}>
          {isShortize && shortize(name)}

          {!isShortize
          && (urlLength
            ? `${name.substring(0, 11)}...`
            : name)}

          {!withoutTooltip && (
          <Tooltip
            isShowTooltip={isShowTooltip}
            text={name.length > 16 ? shortize(name, 16) : name}
          />
          )}
        </div>

        {version && <Version version={version} />}
      </div>
    </div>
  );

  if (!to && !href) {
    return (
      <>
        {content}
      </>
    );
  }

  return (
    <>
      {to ? (
        <Link to={to} className={cx(s.link, className)}>
          {content}
        </Link>
      ) : (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className={className}
        >
          {content}
        </a>
      )}
    </>
  );
};

export default TokenName;
